/* eslint-disable no-irregular-whitespace */
import image03 from "@/assets/newHome/image-3.png";
import { FooterByAnima } from "./FooterByAnima";
import { useLayoutEffect, useRef } from "react";

const TermsAndConditions = () => {
  const mainRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <>

    {/* Top Banner with Background Image */}
    <div ref={mainRef} className="relative w-full h-[200px] md:h-[250px] lg:h-[300px] bg-[#F1FDF5] flex items-center justify-start">

    <h1 className="text-4xl md:text-4xl font-bold text-left text-gray-800 z-10 pl-[3rem] md:pl-[7rem] lg:pl-[5rem] xl:pl-[5rem]">Terms & Conditions</h1>        <div className="absolute left-0 bottom-0 w-full opacity-30 z-0">
          <img
            className="w-full object-contain pointer-events-none"
            alt="Construction project showcase"
            src={image03}
          />
        </div>
    </div>


    <div  className="min-h-screen  px-6 py-10 md:px-20 lg:px-10 ">


        <div className="max-w-full mx-auto bg-white p-8 rounded-2xl">
          {/* <h1 className="text-3xl font-bold text-gray-800 mb-4">Terms & Conditions</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: April 22, 2025</p> */}

          <div className="space-y-6 text-gray-700 text-base leading-7">
            <section>

              <p className="text-[#0d121f] text-[18px]">
                This End-User License Agreement (the "Agreement") is a legal
                agreement between you (either an individual or a single entity
                and referred to as "You" or "User") and BuildMapper Ltd.
                (referred to as "BuildMapper").
              </p>
              <p className="py-[20px] text-[#0d121f] text-[18px]">
                IF YOU WISH TO USE THE BUILDMAPPER SYSTEM YOU MUST CLICK "I
                AGREE" SIGNIFYING YOUR AGREEMENT TO THIS AGREEMENT. IF YOU DO
                NOT AGREE, YOU MAY NOT USE THE BUILDMAPPER.
              </p>
              <p className="pb-[20px] text-[#0d121f] text-[18px]">
                In consideration of the mutual promises and covenants contained
                in this Agreement, and other good and valuable consideration,
                the receipt and sufficiency of which is hereby acknowledged, You
                and BuildMapper hereby agree to be bound by the following:
              </p>
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold mb-2 text-primary">
                REGISTRATION
              </h2>
              <p className="text-[#0d121f] text-[18px]">
                "BuildMapper Trusted User Identification" means the
                identification name(s), number(s) and/or password(s) provided by
                BuildMapper to a User to access the BuildMapper Systems under a
                User Account;
              </p>
              <p className="text-[#0d121f] text-[18px]">
                "User Account" means an account established by BuildMapper for a
                User;
              </p>
              <p className="text-[#0d121f] text-[18px]">
                "Website" means the website located at www.buildmapper.ai
                operated by BuildMapper.
              </p>
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
                SYSTEM LICENSE
              </h2>

              <p className="text-[#0d121f] text-[18px]">
                The BuildMapper System is proprietary to BuildMapper. Subject to
                the User's acceptance of this Agreement, BuildMapper grants to
                the User a non-transferable, non-exclusive, limited license to
                use the BuildMapper System for the User's bona fide internal
                business purposes with no right to sublicense (the "License").
              </p>

              <p className="text-[#0d121f] text-[18px]">
                BuildMapper reserves all rights not explicitly granted herein.
                The License granted to the User in this Agreement herein is
                non-exclusive. Nothing in this Agreement shall be construed as
                limiting in any manner BuildMapper's marketing or distribution
                activities or the licensing of the BuildMapper System by
                BuildMapper to any other person.
              </p>

              <p className="text-[#0d121f] text-[18px]">The User shall not:</p>

              <p className="text-[#0d121f] text-[18px]">
                use, copy, republish or distribute the BuildMapper System, or
                cause or permit any person to use, copy, republish or distribute
                the BuildMapper System, except as expressly permitted under this
                Agreement;
              </p>

              <p className="text-[#0d121f] text-[18px]">
                loan, sell, rent, lease, timeshare, sublicense, grant a security
                interest in, or otherwise attempt to transfer its license to the
                BuildMapper System, in whole or in part to any person;
              </p>

              <p className="text-[#0d121f] text-[18px]">
                use the BuildMapper System in a facility management or Service
                Bureau manner or permit third parties to access the BuildMapper
                System over the Internet. "Service Bureau" means an arrangement
                pursuant to which (i) third parties are permitted to access and
                use the BuildMapper System, directly or indirectly, by any means
                to process their own data or (ii) User uses the BuildMapper
                System to process the data of any third party;
              </p>

              <p className="text-[#0d121f] text-[18px]">
                except to the extent that these restrictions are void under
                applicable law, directly or indirectly attempt in any way to
                rewrite, reorganize, reproduce, decompile, disassemble, reverse
                engineer or translate the BuildMapper System, create derivative
                works thereof, or circumvent any usage or other restrictions
                imposed by BuildMapper;
              </p>
              <p className="text-[#0d121f] text-[18px]">
                remove, alter or modify any proprietary notices or labels from
                the BuildMapper System.{" "}
              </p>
              <p className="text-[#0d121f] text-[18px]">
                The User acknowledges and agrees that this Agreement does not
                grant the User any rights to use any trade-marks or trade names
                of BuildMapper or their licensors. All such marks shall remain
                the property of their respective owner.{" "}
              </p>
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
                ACCOUNT AND PASSWORDS
              </h2>

              <p className="text-[#0d121f] text-[18px]">The User covenants and agrees with BuildMapper as follows:</p>

              <p className="text-[#0d121f] text-[18px]">
                the User will provide BuildMapper with accurate and complete
                information as required by BuildMapper to complete the User
                Profile;
              </p>

              <p className="text-[#0d121f] text-[18px]">
                the User will notify BuildMapper of any change in the
                information provided to BuildMapper or of any misuse or
                potential misuse of the BuildMapper Trusted User Identification
                or User Profile within ten (10) days of such changes or
                information becoming known to the User;
              </p>

              <p className="text-[#0d121f] text-[18px]">
                the User consents to BuildMapper using and storing any
                information the User provides to BuildMapper to fulfill the
                purposes of this Agreement;
              </p>

              <p className="text-[#0d121f] text-[18px]">
                the User acknowledges and agrees that BuildMapper has the right,
                but not the obligation, to validate any information the User
                discloses to BuildMapper;
              </p>

              <p className="text-[#0d121f] text-[18px]">
                the User covenants that all information the User provides to
                BuildMapper under this Agreement, including any statements made
                verifying the identity of the User's staff are true, accurate
                and complete; and
              </p>

              <p className="text-[#0d121f] text-[18px]">
                the User confirms that the User, if a person, is not a minor in
                the User's jurisdiction.
              </p>
              <p className="text-[#0d121f] text-[18px]">
                The User acknowledges and agrees that the establishment of a
                User Account and User Profile does not entitle the User to use
                any software application or service provided by BuildMapper or
                by any other third party other than the BuildMapper System.
              </p>
              <p className="text-[#0d121f] text-[18px]">
                If the User wishes to obtain access to any other software
                application or service, the User must enter into a separate
                agreement with the respective software application or service
                provider. Without limiting the generality of the foregoing, the
                User acknowledges and agrees that the User is solely responsible
                to ensure that the software applications or services are
                suitable for the User's needs and that each of the software
                applications or service providers have agreed to deal with the
                User's information in a manner acceptable to the User.
              </p>
              <p className="text-[#0d121f] text-[18px]">
                The User covenants to take all reasonable steps to preclude any
                third party access to the confidential User Profile or the
                BuildMapper Trusted User Identification including, without
                limitation:
              </p>
              <p className="text-[#0d121f] text-[18px]">
                maintaining, in strict confidence, any password that limits
                access to the BuildMapper System or is used to establish the
                User's identity in communications with BuildMapper;
              </p>
              <p className="text-[#0d121f] text-[18px]">
                ensuring the BuildMapper System is turned off when not in use or
                in attendance by the User.
              </p>
              <p className="text-[#0d121f] text-[18px]">
                The User acknowledges and agrees that BuildMapper, in its sole
                discretion, may:
              </p>
              <p className="text-[#0d121f] text-[18px]">
                refuse to establish a User Profile and/or a User Account; or
              </p>
              <p className="text-[#0d121f] text-[18px]">
                cancel or suspend the User Account and/or access to the
                BuildMapper System, if BuildMapper reasonably believes that the
                BuildMapper System has been or may be misused by the User or any
                third party who has obtained access to the BuildMapper System.
              </p>
              <p className="text-[#0d121f] text-[18px]">
                The User shall notify BuildMapper immediately if the User
                becomes aware of any unauthorized use of the whole or any part
                of the BuildMapper System, the User Account, the User Profile or
                the BuildMapper Trusted User Identification.
              </p>
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold mb-2 text-primary">
                BUILDMAPPER OBLIGATIONS
              </h2>
              <p className="text-[#0d121f] text-[18px]">BuildMapper shall:</p>
              <p className="text-[#0d121f] text-[18px]">
                upon receipt of satisfactory User information, establish a User
                Account and a User Profile;
              </p>
              <p className="text-[#0d121f] text-[18px]">
                provide the User with the BuildMapper Trusted User
                Identification to enable the User to access the BuildMapper
                System;
              </p>
              <p className="text-[#0d121f] text-[18px]">
                provide the User with information from time to time regarding
                the BuildMapper System and software applications and services of
                BuildMapper's associated suppliers; and{" "}
              </p>
              <p className="text-[#0d121f] text-[18px]">
                subject to the terms of this Agreement, protect any information
                that the User provides in a manner consistent with applicable
                legislation and in accordance with BuildMapper privacy policies
                as amended from time to time which are available for review on
                the Website.
              </p>
              <p className="text-[#0d121f] text-[18px]">
                BuildMapper may, at its discretion, store data and records
                generated by Users on the BuildMapper System. Notwithstanding
                the foregoing, the User shall be responsible for all data and
                records generated by the User including, without limitation, the
                backup and storage of such data and records. BuildMapper shall
                not be responsible for any lost or corrupted data or records
                generated by Users and stored on the BuildMapper System.
              </p>
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
                DISCLAIMER AND LIMITATION OF LIABILITY
              </h2>

              <p className="text-[#0d121f] text-[18px]">
                BUILDMAPPER DISCLAIMS ANY AND ALL REPRESENTATIONS AND WARRANTIES
                WITH RESPECT TO THE BUILDMAPPER SYSTEM, EITHER EXPRESS OR
                IMPLIED, INCLUDING, BUT NOT LIMITED TO, THIRD PARTY
                INFRINGEMENT, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
                FOR A PARTICULAR PURPOSE. THE USER ACKNOWLEDGES THAT IT HAS NOT
                RELIED ON ANY REPRESENTATION OR WARRANTY MADE BY BUILDMAPPER OR
                ANY OTHER PERSON. THE BUILDMAPPER SYSTEM IS PROVIDED ON AN "AS
                IS" BASIS WITH NO WARRANTY, OR REPRESENTATION EXPRESS OR IMPLIED
                AND BUILDMAPPER HAS NO OBLIGATION TO PROVIDE MAINTENANCE,
                SUPPORT, UPDATES, ENHANCEMENTS OR MODIFICATIONS WITH RESPECT TO
                THE BUILDMAPPER SYSTEM TO THE USER.
              </p>

              <p className="text-[#0d121f] text-[18px]">
                IN NO EVENT SHALL BUILDMAPPER BE LIABLE FOR ANY DAMAGES SUFFERED
                OR INCURRED BY THE USER OR ANY OTHER PERSON OR ENTITY INCLUDING,
                WITHOUT LIMITATION, ANY SPECIAL, INCIDENTAL, INDIRECT, DIRECT,
                PUNITIVE OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT
                LIMITATION, DAMAGES FOR LOSS OF BUSINESS PROFITS, LOSS OF
                REVENUE, BUSINESS INTERRUPTION, LOSS OF BUSINESS INFORMATION, OR
                ANY OTHER PECUNIARY LOSS) ARISING OUT OF THE USE OF OR INABILITY
                TO USE THE BUILDMAPPER SYSTEM, EVEN IF BUILDMAPPER HAS BEEN
                ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IF THE USER IS
                DISSATISFIED WITH THE BUILDMAPPER SYSTEM, THE USER'S SOLE REMEDY
                SHALL BE TO TERMINATE THE AGREEMENT.
              </p>

              <p className="text-[#0d121f] text-[18px]">
                THE USER ACKNOWLEDGES AND AGREES THAT THE LIMITATIONS OF
                LIABILITY SET OUT IN PART 5 ARE FAIR AND REASONABLE IN THE
                COMMERCIAL CIRCUMSTANCES OF THIS AGREEMENT AND THAT BUILDMAPPER
                WOULD NOT HAVE ENTERED INTO THIS AGREEMENT NOR PROVIDED ACCESS
                TO THE BUILDMAPPER SYSTEM BUT FOR THE USER'S AGREEMENT TO LIMIT
                BUILDMAPPER'S LIABILITY IN THE MANNER, AND TO THE EXTENT,
                PROVIDED FOR HEREIN.
              </p>
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              ENDORSEMENTS, COMMUNICATION AND LINKS TO EXTERNAL SITES
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              BuildMapper is not responsible for the contents of any third party sites or services, any links contained in third party sites or services, or any changes or updates to third party sites or services.  BuildMapper provides these links and access to third party sites and services to the User only as a convenience and the including of any link or access does not imply an endorsement by BuildMapper of the third party site or service.
              </p>

              <p className="text-[#0d121f] text-[18px]">
              Nothing in this Agreement, nor the License shall constitute or imply any promise to or intention to make any purchase of products or services by either party or its affiliates or any commitment by either party or its affiliates with respect to the present or future marketing of any product or service or any commitment to enter into any other business relationship.
              </p>

            </section>


            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              INDEMNITY AND REMEDIES
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              The User shall defend, indemnify and save BuildMapper and its respective directors, officers, employees, agents, affiliates, shareholders or any combination thereof harmless from any claims, costs (including settlement and legal or other professional fees on a solicitor and own client basis), damages, expenses, losses, and liability arising out of or relating to, either directly or indirectly,  the User's use of the BuildMapper System, any breach by the User of its obligations under this Agreement, any unauthorized alteration, modification, adjustment or enhancement made by the User to the BuildMapper System or the misuse of a Trusted User Identification, a User Account or information recorded in a User Profile by the User.
              </p>

              <p className="text-[#0d121f] text-[18px]">
              The User agrees that, in addition to any other rights or remedies BuildMapper may have for any breach of this Agreement, BuildMapper has the right to an injunction or other equitable relief in any court of competent jurisdiction enjoining a threatened or actual breach of this Agreement by the User.
              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              FEES AND PAYMENT ACCOUNTS
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              Users may pay monies into the Users Payment Account by way of cheque or credit card payment and fees are due on a monthly recurring basis.
              </p>

              <p className="text-[#0d121f] text-[18px]">
              BuildMapper reserves the right to withhold the delivery and/or suspend the User's access to the BuildMapper System should the User be in default of payment.
              </p>

            </section>
            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              FUTURE AMENDMENT OF TERMS
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              The User acknowledges that BuildMapper may modify the terms and conditions of this Agreement in its sole discretion at any time by posting a revised version of the Agreement on the Website.  The User's continued use of the BuildMapper System and/or BuildMapper services shall be evidence of the User's acceptance of any such modified terms and conditions of this Agreement.
              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              TERMINATION
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              Either party may terminate this Agreement immediately for any reason by providing the other party with a written termination notice ("Termination Notice").  Upon issuance or receipt of a Termination Notice BuildMapper shall be deemed to have received an Account Closure Notice.

Promptly upon termination of this Agreement, but in any event not less than one (1) day after termination, the User shall return to BuildMapper or, upon the written instructions of BuildMapper, destroy any and all copies of the BuildMapper System in its possession or control and confirm such destruction in writing to BuildMapper.              </p>

              <p className="text-[#0d121f] text-[18px]">
              Promptly upon termination of this Agreement, but in any event not less than one (1) day after termination, the User shall return to BuildMapper or, upon the written instructions of BuildMapper, destroy any and all copies of the BuildMapper System in its possession or control and confirm such destruction in writing to BuildMapper.              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              NOTICE
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              Any notice required or permitted to be given under this Agreement shall be in writing and shall be effective upon its delivery by courier or delivery by electronic mail to the last civic address or e-mail address provided by the recipient to the other party.              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              SURVIVAL
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              The User acknowledges, covenants and agrees that due to the proprietary nature of the BuildMapper System, the provisions of this Agreement, including, without limitation Part 5 and 7 of this Agreement, will continue in full force and effect notwithstanding the termination of this Agreement for any reason.</p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              ASSIGNMENT
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              The User will not assign this Agreement, either directly or indirectly, without the prior written consent of BuildMapper which may be withheld by BuildMapper for any reason in its sole and unfettered discretion.
              </p>

              <p className="text-[#0d121f] text-[18px]">
              No subcontract entered into by the User with any third party will:
              </p>
              <p className="text-[#0d121f] text-[18px]">
              relieve the User of the obligations under this Agreement; or
              </p>
              <p className="text-[#0d121f] text-[18px]">
              create any obligation or liability to any such subcontractor upon BuildMapper.
              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              GOVERNING LAW
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              This Agreement will be governed by and construed in accordance with the laws of the Province of British Columbia and the laws of Canada applicable therein.  The parties agree that the Courts of the Province of British Columbia shall have exclusive jurisdiction to hear and make any judicial determination on any issue arising with respect to this Agreement. The parties expressly exclude the UN Convention on Contracts for the International Sale of Goods as amended, replaced or re-enacted from time to time.  The parties have required that this Agreement and all documents relating thereto be drawn-up in English. NOUS avons demande que cette convention ainsi que tous les documents qui s'y rattachent soient rediges en anglais.
              </p>

            </section>


            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              SEVERABILITY
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              If a court of competent jurisdiction concludes that any provision of this Agreement is illegal, invalid or unenforceable, then it shall be severed from this Agreement and the remaining provisions shall remain in full force and effect.
              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              BINDING EFFECT
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              By clicking the I AGREE button set out below and/or by accepting delivery of the BuildMapper System, copying, accessing or otherwise using the BuildMapper System, the User represents and warrants to BuildMapper that the User has all requisite power and authority to enter into this Agreement and has all necessary power and authority to perform the obligations of the User as set out herein.
              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              ENUREMENT
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              The Agreement will be for the benefit of and binding upon the heirs, executors, representatives, administrators, successors and permitted assigns of the User.
              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              ENTIRE AGREEMENT
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              This Agreement constitutes the entire understanding between the parties hereto and supersedes all previous communications, representations and understandings, oral or written, between the parties, with respect to the subject matter of this Agreement.
              </p>
              <p className="text-[#0d121f] text-[18px]">
              This Agreement constitutes the entire understanding between the parties hereto and supersedes all previous communications, representations and understandings, oral or written, between the parties, with respect to the subject matter of this Agreement.

BY CLICKING THE "I AGREE" BUTTON SET OUT BELOW, YOU, AS THE USER INDICATE YOUR ACCEPTANCE OF THIS AGREEMENT AND CERTIFY THAT YOU HAVE ALL THE REQUISITE POWER AND AUTHORITY TO ENTER INTO THIS AGREEMENT AND ACCEPT THE TERMS AND CONDITIONS OF THIS AGREEMENT.  IF YOU DO NOT AGREE, YOU MAY NOT USE THE BUILDMAPPER SYSTEM AND MUST PROMPTLY RETURN ANYTHING ASSOCIATED WITH THE BUILDMAPPER SYSTEM TO BUILDMAPPER.              </p>

            </section>




          </div>
        </div>
      </div>
      <FooterByAnima />
    </>
  );
};

export default TermsAndConditions;
